'use client'

import { useEffect } from 'react'
// Error components must be Client Components
import { Button } from '@/components/button'
import { T } from '@/components/t'

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    useEffect(() => {
        // Log the error to an error reporting service
        // biome-ignore lint/suspicious/noConsole: intentional error logging
        console.error(error)
    }, [error])

    return (
        <div className="flex flex-col items-center justify-center w-full max-h-dvh h-[700px] max-w-[350px] mx-auto">
            <T t="specialPages.error.title" h1 className="text-[48px] mb-4 text-center" />

            <T
                t="specialPages.error.description"
                p
                className="text-[21px] text-black/70 max-w-[400px] text-center mb-6"
            />

            <Button styleType="primary" onClick={reset} shape="pill" height="50px">
                <T t="specialPages.error.cta" span />
            </Button>
        </div>
    )
}
